<template>
     <div :class="keyboardClass" class="keypad"></div>
</template>
<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
export default {
    name: 'KeyPadOrder',
    props: {
        keyboardClass: {
            default: "simple-keyboard",
            type: String
        },
        input: {
            type: String
        }, 
        inputName: {
            type: String
        }
    },
    data: () => ({
        keyboard: null
    }),
    mounted() {
        this.init();
    },
    methods: {
        init(){
            this.keyboard = new Keyboard({
                onChange: this.onChange,
                onKeyPress: this.onKeyPress,
                layout: {
                        default: ["{numpad1} {numpad2} {numpad3}", "{numpad4} {numpad5} {numpad6}", "{numpad7} {numpad8} {numpad9}", "0 00 {bksp}"] 
                    },
                theme: "hg-theme-default hg-layout-numeric numeric-theme",
                
                display: { 
                    "{bksp}": "⌫", 
                },
                physicalKeyboardHighlight: true,
                syncInstanceInputs: true,
                mergeDisplay: true,
            });
        },
        clearInput(){
            this.keyboard.clearInput();
        },
        onChange(input) {
            this.$emit("onChange", input);
        },
        onKeyPress(button) { 
            this.$emit("onKeyPress", button); 
            if (button === "{shift}" || button === "{lock}") this.handleShift();
        },
        handleShift() {
            let currentLayout = this.keyboard.options.layoutName;
            let shiftToggle = currentLayout === "default" ? "shift" : "default";
            this.keyboard.setOptions({
                layoutName: shiftToggle
            });
        }
    },
    watch: {
        inputName(inputName) { 
            this.keyboard.setOptions({ inputName });
        },
        input(input) { 
            this.keyboard.setInput(input); 
        }
    },
    destroyed(){ 
        this.keyboard.destroy(); 
    }
}
</script>

<style scoped>
 
</style>